/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints, typography2 } from '@coursera/cds-core';

import type { ConsumerPageHeader_EnterpriseProgramFragment as EnterpriseProgramFragment } from 'bundles/composable-page-header-consumer/queries/__generated__/ConsumerMyPageHeaderQuery';
import EnterpriseSearchBar from 'bundles/search-common/components/searchbar/enterprise/SearchBar';

import _t from 'i18n!nls/composable-page-header-enterprise';

type Props = {
  thirdPartyOrganizationSlug?: string;
  enrolledEnterprisePrograms?: Partial<EnterpriseProgramFragment>[] | null;
};

const styles = {
  searchBar: css`
    && {
      ${breakpoints.up('lg')} {
        width: 100%;
      }

      .rc-EnterpriseSearchBarV2 {
        max-width: 480px;
        min-width: 0;
        width: 100%;

        input {
          /* Needs important to override old style that's also set to important. Yuck! */
          font: ${typography2.bodySecondary.font} !important;
          letter-spacing: ${typography2.bodySecondary.letterSpacing};
        }
      }
    }
  `,
};

export function EnterpriseOrgScopedSearchBarGridItem(props: Props) {
  const { thirdPartyOrganizationSlug, enrolledEnterprisePrograms } = props;

  if (!thirdPartyOrganizationSlug || !enrolledEnterprisePrograms?.length) {
    return null;
  }

  const programIds: Array<string> =
    enrolledEnterprisePrograms
      ?.filter((program) => program?.naptimeThirdPartyOrganization?.slug === thirdPartyOrganizationSlug)
      ?.map((program) => program?.id ?? '') ?? [];

  return (
    <div data-testid="org-scoped-enterprise-search-bar" css={styles.searchBar}>
      <EnterpriseSearchBar
        enterpriseSearchBarConfig={{
          programIds,
          pathname: `/programs/all/${thirdPartyOrganizationSlug}`,
          searchResultsBasePath: `/programs/all/${thirdPartyOrganizationSlug}`,
          placeholder: _t('Search in all programs you joined...'),
        }}
      />
    </div>
  );
}

export default EnterpriseOrgScopedSearchBarGridItem;
